/**
 * Composable for toggling the visibility of the vue-map-container element.
 * 
 * This composable provides a function to toggle the 'd-none' class on the
 * vue-map-container div, which is used to hide/show the map container based
 * on the map open state.
 * 
 * @returns {Function} toggleMapContainerVisibility - Function that toggles the d-none class
 */
const useMapContainerVisibility = () => {
	/**
	 * Toggles the 'd-none' class on the vue-map-container div based on isMapOpen state.
	 * 
	 * @function toggleMapContainerVisibility
	 * @param {boolean} isOpen - Whether the map is open
	 * @returns {void}
	 */
	const toggleMapContainerVisibility = (isOpen: boolean): void => {
		const mapContainer = document.querySelector('.vue-map-container');
		if (mapContainer) {
			if (isOpen) {
				mapContainer.classList.remove('d-none');
			} else {
				mapContainer.classList.add('d-none');
			}
		}
	};

	return {
		toggleMapContainerVisibility
	};
};

export default useMapContainerVisibility;
